export default __webpack_public_path__ + "static/media/2017 GENERAL INFORMATION SHEET (GIS).41452e5e.pdf";